(function () {
  'use strict';

  angular.module('app').component('paymentGatewayDetail', paymentGatewayDetail());

  function paymentGatewayDetail() {
    return {
      bindings: {
        item: '=',
        mode: '<',
        onPaymentGatewaySaved: '&',
        onPaymentGatewayCanceled: '&',
        paymentMethods: '<',
        defaultLanguage: '<',
        additionalLanguages: '<',
      },
      controller: PaymentGatewayDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/payment-gateways/payment-gateway-detail/payment-gateway-detail.component.html',
    };
  }

  PaymentGatewayDetailComponent.$inject = ['UtilService', 'PaymentGatewayService'];

  function PaymentGatewayDetailComponent(UtilService, PaymentGatewayService) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    // private properties
    // -----------------------
    let fieldsDefinition = [
      'name',
      'enabled',
      'system_enabled',
      'website_enabled',
      'is_default',
      'payment_method_id',
    ];

    vm.$onInit = function () {
      setItemOptions(vm.item, vm.mode);
      setPaymentMethodFieldsDefinition(vm.item);
    };

    // public methods
    // -----------------------
    vm.editPaymentGateway = function () {
      vm.editMode = true;
      vm.viewMode = false;
    };

    vm.cancelEdit = function () {
      vm.item = vm.originalItem;
      setItemOptions(vm.item);
    };

    vm.openTranslations = function () {
      PaymentGatewayService.openPaymentGatewayTranslations(vm.item, vm.additionalLanguages);
    };

    // Update
    vm.savePaymentGateway = function (isFormValid) {
      if (!isFormValid) {
        vm.serverErrors = [];

        return;
      }

      if (vm.UtilService.isFormDataChanged(vm.item, vm.originalItem, fieldsDefinition)) {
        vm.sendingForm = true;
        PaymentGatewayService.savePaymentGateway(vm.item).then(function (data) {
          if (!data.errors) {
            // success
            // setItemOptions(data); // not needed as it closes the modal
            vm.onPaymentGatewaySaved({ item: data });
          } else {
            vm.serverErrors = vm.UtilService._showItemServerErrors(data.errors);
          }

          vm.sendingForm = false;
        });
      } else {
        vm.cancel();
      }
    };

    vm.cancel = function () {
      /*if (vm.editMode){
                vm.cancelEdit();
                return;
            }*/

      vm.onPaymentGatewayCanceled();
    };

    // private methods
    // -----------------------
    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      vm.item.enabled = item.enabled || false; // Fix null, remove later

      if (mode === 'edit') {
        vm.editPaymentGateway();
      }

      vm.originalItem = angular.copy(vm.item); // store server data
    }

    function setPaymentMethodFieldsDefinition(item) {
      switch (item.idt) {
        // Paypal
        case 'paypal':
          fieldsDefinition.push('paypal_client_id', 'paypal_client_secret');
          break;

        // Bac ecommerce usd
        case 'bac_ecommerce_usd':
          fieldsDefinition.push('bac_processor_id_usd', 'bac_key_id_usd', 'bac_key_usd');
          break;

        // Bac ecommerce crc
        case 'bac_ecommerce_crc':
          fieldsDefinition.push('bac_processor_id_crc', 'bac_key_id_crc', 'bac_key_crc');
          break;

        // Bcr ecommerce usd
        case 'bcr_ecommerce_usd':
          fieldsDefinition.push('bcr_login_id_usd', 'bcr_transaction_key_usd');
          break;

        // Bcr ecommerce crc
        case 'bcr_ecommerce_crc':
          fieldsDefinition.push('bcr_login_id_crc', 'bcr_transaction_key_crc');
          break;
      }
    }
  }
})();

/*function getPaymentMethods(){
            vm.loadingPaymentMethods = true;
            PaymentMethodService.getPaymentMethods({ get: 'active', skip_check_role: true }).then(function () {
                vm.paymentMethods = PaymentMethodService.items;

                vm.loadingPaymentMethods = false;
            });
        }*/
